import { render, staticRenderFns } from "./AxumDetails.vue?vue&type=template&id=d52290f4&scoped=true&"
import script from "./AxumDetails.vue?vue&type=script&lang=js&"
export * from "./AxumDetails.vue?vue&type=script&lang=js&"
import style0 from "./AxumDetails.vue?vue&type=style&index=0&id=d52290f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52290f4",
  null
  
)

export default component.exports